var angular = require('angular');
var _module = angular.module('listreports.events', []);


_module.provider('$events', [
    function() {
        var plugins = [];

        return {
            register: function(plugin) {
                plugins.push(plugin);
            },
            $get: function() {
                return {
                    setSuperProperties: function(superProperties) {
                        angular.forEach(plugins, function(plugin) {
                            if(plugin.hasOwnProperty('setSuperProperties'))
                                plugin.setSuperProperties(superProperties || {});
                        });
                    },
                    setSuperPropertiesOnce: function(superProperties) {
                        angular.forEach(plugins, function(plugin) {
                            if(plugin.hasOwnProperty('setSuperPropertiesOnce'))
                                plugin.setSuperPropertiesOnce(superProperties || {});
                        });
                    },
                    track: function(event, properties) {
                        angular.forEach(plugins, function(plugin) {
                            if(plugin.hasOwnProperty('track'))
                                plugin.track(event, properties || {});
                        });
                    }
                };
            }
        };
    }
]);
